import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps'; // @ts-expect-error untyped dependency

import LoadingWrapper from 'ecosystem-marketplace-core/components/LoadingWrapper';
import StorefrontResultsSection from '../../components/storefront/results/StorefrontResultsSection';
import { searchAssets } from '../../clients/ecosystemClient';
import RouterAssetCard from '../RouterAssetCard';
import { useOfferingType } from '../../context/OfferingTypeContext';

const SectionLoadingComponent = () => {
  return /*#__PURE__*/_jsx(UILoadingSpinner, {
    minHeight: 150,
    layout: "centered"
  });
};

const ErrorComponent = () => {
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.details.recommendations.error"
    })
  });
};

const ResultComponent = ({
  index,
  result,
  resultsLength,
  trackInteraction,
  trackPageview
}) => {
  return /*#__PURE__*/_jsx(RouterAssetCard, {
    onClick: () => {
      trackInteraction('click result item', {
        value: result.slug,
        itemIndex: index,
        totalResults: resultsLength
      });
    },
    onTrackInteraction: trackInteraction,
    onTrackPageview: trackPageview,
    result: result,
    view: "grid"
  });
};

export default function AssetResultsSectionDataContainer(_ref) {
  let {
    maxColumns,
    offeringId,
    responsive,
    searchQuery
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["maxColumns", "offeringId", "responsive", "searchQuery"]);

  const offeringType = useOfferingType();
  const [requestState, setRequestState] = useState(RequestStates.UNINITIALIZED);
  const [searchResponse, setSearchResponse] = useState(null);
  useEffect(() => {
    if (requestState === RequestStates.UNINITIALIZED) {
      setRequestState(RequestStates.PENDING);
      const request = Promise.resolve(searchQuery).then(query => searchAssets(offeringType, [query]));
      request.then(([resp]) => {
        setSearchResponse(resp);
        setRequestState(RequestStates.SUCCEEDED);
      }).catch(error => {
        console.error('error fetching collection\n', error);
        setSearchResponse(null);
        setRequestState(RequestStates.FAILED);
      });
    }
  }, [offeringType, requestState, searchQuery]);
  const {
    mobileResultsSize
  } = useResponsiveProps({
    mobileResultsSize: {
      xs: 2,
      md: maxColumns
    }
  });
  const totalResultsSize = useMemo(() => {
    return responsive ? mobileResultsSize : maxColumns;
  }, [mobileResultsSize, maxColumns, responsive]);
  const displayedResults = useMemo(() => {
    const results = searchResponse ? searchResponse.items : [];

    if (offeringId) {
      const filteredResults = results.filter(result => result.offeringId !== offeringId);

      if (totalResultsSize && filteredResults.length > totalResultsSize) {
        return filteredResults.slice(0, totalResultsSize);
      }

      return filteredResults;
    }

    return results;
  }, [offeringId, searchResponse, totalResultsSize]);

  if (displayedResults.length < 1) {
    return null;
  }

  return /*#__PURE__*/_jsx(LoadingWrapper, {
    ErrorComponent: ErrorComponent,
    LoadingComponent: SectionLoadingComponent,
    requestStatus: requestState,
    children: /*#__PURE__*/_jsx(StorefrontResultsSection, Object.assign({}, rest, {
      results: displayedResults,
      ResultComponent: ResultComponent
    }))
  });
}